import React from 'react';
import { Avatar, AvatarProps } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SxProps, Theme } from '@mui/material/styles';

interface ClickableAvatarProps extends Omit<AvatarProps, 'onClick'> {
  userId?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  sx?: SxProps<Theme>;
}

const ClickableAvatar: React.FC<ClickableAvatarProps> = ({
  userId,
  onClick,
  sx,
  ...avatarProps
}) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (onClick) {
      onClick(e);
    } else if (userId) {
      navigate(`/browse-handyman/${userId}`);
    }
  };

  return (
    <Avatar
      {...avatarProps}
      onClick={handleClick}
      sx={{
        cursor: userId || onClick ? 'pointer' : 'default',
        transition: 'transform 0.2s ease-in-out, opacity 0.2s ease-in-out, boxShadow 0.2s ease-in-out',
        '&:hover': userId || onClick ? {
          transform: 'scale(1.05)',
          opacity: 0.9,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1)',
        } : {},
        ...sx,
      }}
    />
  );
};

export default ClickableAvatar;

